import { useNodeConnections } from '@xyflow/react';
import type { HandleType } from '@xyflow/system';
import type { UUIDType } from '../../../../common/utils';
import { getHandleId } from '../utils';

export const useConnection = (
  nodeId: UUIDType,
  itemIndex: number,
  handleType: HandleType,
) => {
  const [connection] = useNodeConnections({
    id: nodeId,
    handleId: getHandleId(nodeId, itemIndex, handleType),
    handleType,
  });
  return connection;
};
